// import { useDispatch } from 'react-redux';
// import {empty} from "./global-functions";
// import {updateEntry} from "_features/entries/entry-slice";
// import {goNextPage} from "./page-flow";
// import {Navigate, useNavigate} from "react-router-dom";
// import React from "react";
import { useNavigate } from "react-router-dom";

export function useActionExecutor() {
    const navigate = useNavigate();

    function execute(action) {

        if (!action || !action.type) {
            return;
        }

        switch (action.type.toLowerCase()) {
            case "navigate":
                navigate(action.value);
                break;

            case "url":
                window.open( action.value, "_self" );
                break;

            case "urlblank":
                window.open( action.value, "_blank", "noopener,noreferrer" );
                break;

            case "print":
                window.print();
                break;

            default:
                console.warn("Unknown action:", action);
        }
    }

    return { execute };
}


// type AppAction = { type: "navigate", to: string } | { type: "external", url: string } | { type: "print" });
//
// export function appActions( action, value, entryAdd ) {
//
//
//
//     const navigate = useNavigate();
//
//     //const ACTION_LIST = ["URL", "URLBLANK", "PRINT", "THANKYOU", "HOME","NAVIGATE"];
//
//     return {
//         navigateTo: (path: string) => navigate(path),
//         externalLink: (url: string) =>
//             window.open(url, "_blank", "noopener,noreferrer"),
//         externalLinkBlank: (url: string) =>
//             window.open(url, "_blank", "noopener,noreferrer"),
//         print: () => window.print(),
//     };

    // // URL Action
    // if ( action.toUpperCase().trim() === "URL" ) {
    //     if ( !empty(value) ) {
    //         alert("here")
    //         window.location.href = value;
    //         return;
    //     }
    // }

    // // URLBlank Action
    // if ( action.toUpperCase().trim() === "URLBLANK" ) {
    //     if ( !empty(value) ) {
    //         window.open(value, '_blank');
    //         return;
    //     }
    // }
    //
    // // Print Action
    // if ( action.toUpperCase().trim() === "PRINT" ) {
    //     window.print();
    //     return;
    // }
    //
    // // Thank You Action
    // if ( action.toUpperCase().trim() === "THANKYOU" ) {
    //     //navigate( "/thank-you" );
    //     return (<Navigate to={"/thank-you"}/>);
    // }
    //
    // // Navigate
    // if ( action.toUpperCase().trim() === "NAVIGATE" ) {
    //     navigate( "/"+value );
    //     return (<Navigate to={"/"+value}/>);
    // }

//}

export function isInternalAction( action ) {
    if ( ACTION_LIST.indexOf( action.toUpperCase().trim() ) >= 0 ) {
        return true;
    } else {
        return false;
    }
}

const handleActionButton1 = () => {

}
